export default __webpack_public_path__ + "static/media/hotels-fitness-studios.2d30bf82.png";